import getConfig from 'next/config'

import {
  UseUserRegistrationsProps,
  useGetUserRegistrations as useGetUserRegistrationsLib,
} from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const useGetUserRegistrations = (
  props: Omit<UseUserRegistrationsProps, 'baseUrl'>
) =>
  useGetUserRegistrationsLib({
    baseUrl: publicRuntimeConfig.WEB_API_URL,
    ...props,
  })
